'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');
const GroupBasedDataService=require('../../../dist-es6/client/services/groupBasedDataService');let

FleetIncidentsDataService=function(_GroupBasedDataServic){_inherits(FleetIncidentsDataService,_GroupBasedDataServic);_createClass(FleetIncidentsDataService,null,[{key:'$inject',get:function()
{
return['$timeout','statisticalDisplayDataService','timeZoneService','groupTreeService'];
}}]);

function FleetIncidentsDataService($timeout,statisticalDisplayDataService,timeZoneService,groupTreeService){_classCallCheck(this,FleetIncidentsDataService);var _this=_possibleConstructorReturn(this,
_GroupBasedDataServic.call(this,$timeout,groupTreeService));
_this._statisticalDisplayDataService=statisticalDisplayDataService;
_this._timeZoneService=timeZoneService;
_this._redirectResolved=!1;

_this._clearPersistentData();return _this;
}FleetIncidentsDataService.prototype.

















_clearPersistentData=function _clearPersistentData(){
_GroupBasedDataServic.prototype._clearPersistentData.call(this);
this._displayInterval=void 0;
this._incidentTypes=void 0;
};FleetIncidentsDataService.prototype.









_update=function(){var ref=_asyncToGenerator(function*(cancellationToken){


const queryInterval=_expandLocalIntervalToContainAllTimeZonesOfSameDay(this._displayInterval,this.localTimeZone);
const{groupTree:groupTree,incidentTypes:incidentTypes}=yield this._statisticalDisplayDataService.fetchFleetIncidentsDataFor({queryInterval:queryInterval});

if(cancellationToken.cancelled){
return;
}

this.groupTree=groupTree;
this._incidentTypes=incidentTypes;
});function _update(cancellationToken){return ref.apply(this,arguments)}return _update}();_createClass(FleetIncidentsDataService,[{key:'localTimeZone',get:function(){return this._timeZoneService.localTimeZone}},{key:'displayInterval',get:function(){return this._displayInterval},set:function(displayInterval){this._displayInterval=displayInterval}},{key:'incidentTypes',get:function(){return this._incidentTypes}},{key:'redirectResolved',get:function(){return this._redirectResolved},set:function(redirectResolved){this._redirectResolved=redirectResolved}}]);return FleetIncidentsDataService}(GroupBasedDataService);


const maxTimezoneOffsetBeforeUTC=timespan.fromHours(14);
const maxTimezoneOffsetAfterUTC=timespan.fromHours(12);

function _expandLocalIntervalToContainAllTimeZonesOfSameDay(displayInterval,localTimeZone){
const intervalInLocalTime=displayInterval.expandToRoundTarget('day',localTimeZone);
const localQueryIntervalShiftedToUTC=intervalInLocalTime.shiftedToTimeZone(localTimeZone,'utc');

const allTimezoneIntervalStartTime=pulsarDate(localQueryIntervalShiftedToUTC.start).minus(maxTimezoneOffsetBeforeUTC);
const allTimezoneIntervalEndTime=pulsarDate(localQueryIntervalShiftedToUTC.end).plus(maxTimezoneOffsetAfterUTC);

return TimeInterval.from(allTimezoneIntervalStartTime).to(allTimezoneIntervalEndTime);
}

module.exports=FleetIncidentsDataService;
module.exports.expandLocalIntervalToContainAllTimeZonesOfSameDay=_expandLocalIntervalToContainAllTimeZonesOfSameDay;
//# sourceMappingURL=fleetIncidentsDataService.js.map
